import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { CenteredSpinner } from '../../../../../components';

export function ConfigureVmFromDiagramLoader(): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <CenteredSpinner />
      <p className="text-center dbl-padding">
        {t('diagram.modals.configureVm.loading.text')}
      </p>
    </>
  );
}
